import { IKImage, IKContext, IKImageProps } from 'imagekitio-react';
import { useEffect, useLayoutEffect, useState } from 'react';
import { getImageKitUrl } from '@utils/imagekit';

export interface ImageKitWrapperProps extends IKImageProps {
  imageUrl: string;
  sizeTransformation?: {
    width?: number | string;
    height?: number | string;
    dpr?: number;
  };
}

const imageKitPublicKey = process.env.NEXT_PUBLIC_IMAGEKIT_PUBLIC_KEY;
const imagekitUrlEndpoint = process.env.NEXT_PUBLIC_IMAGEKIT_URL_ENDPOINT;

const useIsomorphicLayoutEffect =
  typeof window !== 'undefined' ? useLayoutEffect : useEffect;

export const ImageKitWrapper = ({
  imageUrl,
  transformation = [],
  sizeTransformation = {} as ImageKitWrapperProps['sizeTransformation'],
  ...otherProps
}: ImageKitWrapperProps) => {
  const [imageKitUrl, setImageKitUrl] = useState(getImageKitUrl(imageUrl));

  transformation = [
    { dpr: 2, ...sizeTransformation },
    { quality: 85 },
    ...transformation,
  ];

  useEffect(() => {
    if (imageUrl) {
      setImageKitUrl(getImageKitUrl(imageUrl));
    }
  }, [imageUrl]);

  if (!imageKitUrl) {
    return null;
  }

  return (
    <IKContext publicKey={imageKitPublicKey} urlEndpoint={imagekitUrlEndpoint}>
      <IKImage
        {...otherProps}
        transformation={transformation}
        path={imageKitUrl}
      ></IKImage>
    </IKContext>
  );
};
